import { addEventEntry, addDataLayerEntry, Events } from '@printdeal/data-layer-manager';
import { CollectionState } from '../index';

const EVENT_CATEGORY = {
  CATEGORY: 'site_search_algolia',
  CATEGORY_STICKY: 'site_search_algolia_sticky',
  NO_RESULTS_FOUND_CTA: 'search_suggestions',
};

const EVENT_ACTION = {
  SUGGESTION_LOAD: 'suggestion_display',
  SUGGESTION_LOAD_STICKY: 'suggestion_display_sticky',
  SUGGESTION_SELECT: 'suggestion_click',
  SUGGESTION_SELECT_STICKY: 'suggestion_click_sticky',
  RECENT_LOAD: 'recent_search_display',
  RECENT_SELECT: 'recent_search_click',
  REQUEST_QUOTE: 'quote_link',
};

const EVENT_LABELS = {
  QUOTE_CLICK: 'click',
};

const getSourceQueriesFromState = (collectionState: CollectionState, sourceId: string): string[] =>
  collectionState
    .filter((collection) => collection?.source?.sourceId === sourceId)
    .flatMap(({ items = [] }) => items)
    .map(({ query }) => query);

export const dispatchDataLayerEventOnSuggestionLoad = (
  collectionState: CollectionState,
  staticHeaderInView?: boolean,
) => {
  const suggestions = getSourceQueriesFromState(collectionState, 'QuerySuggestions');
  const eventLabel = suggestions.length ? JSON.stringify(suggestions) : undefined;
  const eventAction = staticHeaderInView === false ? EVENT_ACTION.SUGGESTION_LOAD_STICKY : EVENT_ACTION.SUGGESTION_LOAD;
  const eventCategory = staticHeaderInView === false ? EVENT_CATEGORY.CATEGORY_STICKY : EVENT_CATEGORY.CATEGORY;

  addDataLayerEntry(
    eventAction,
    {
      product_name: eventLabel,
      eventNonInteraction: true,
    },
  );

  addEventEntry({
    eventCategory,
    eventAction,
    eventNonInteraction: true,
    eventLabel,
  });
};

export const dispatchDataLayerEventOnRecentSearchLoad = (collectionState: CollectionState) => {
  const recentSearches = getSourceQueriesFromState(collectionState, 'RecentSearches');
  const eventLabel = recentSearches.length ? JSON.stringify(recentSearches) : undefined;
  const eventAction = EVENT_ACTION.RECENT_LOAD;
  const eventCategory = EVENT_CATEGORY.CATEGORY;

  addDataLayerEntry(
    eventAction,
    {
      product_name: eventLabel,
      eventNonInteraction: true,
    },
  );

  addEventEntry({
    eventCategory,
    eventAction,
    eventNonInteraction: true,
    eventLabel,
  });
};

export const dispatchDataLayerEventOnSuggestionSelect = (value: string, staticHeaderInView?: boolean) => {
  const eventAction = staticHeaderInView === false
    ? EVENT_ACTION.SUGGESTION_SELECT_STICKY : EVENT_ACTION.SUGGESTION_SELECT;
  const eventCategory = staticHeaderInView === false ? EVENT_CATEGORY.CATEGORY_STICKY : EVENT_CATEGORY.CATEGORY;

  addDataLayerEntry(
    eventAction,
    {
      product_name: value,
      eventNonInteraction: false,
    },
  );

  addEventEntry({
    eventCategory,
    eventAction,
    eventNonInteraction: false,
    eventLabel: value,
  });
};

export const dispatchDataLayerEventOnRecentSearchSelect = (value: string) => {
  const eventAction = EVENT_ACTION.RECENT_SELECT;
  const eventCategory = EVENT_CATEGORY.CATEGORY;

  addDataLayerEntry(
    eventAction,
    {
      product_name: value,
      eventNonInteraction: false,
    },
  );

  addEventEntry({
    eventCategory,
    eventAction,
    eventNonInteraction: false,
    eventLabel: value,
  });
};

export const dispatchDataLayerEventOnNoResultsRequestQuoteGA = () => {
  addDataLayerEntry(Events.Event, {
    eventCategory: EVENT_CATEGORY.NO_RESULTS_FOUND_CTA,
    eventAction: EVENT_ACTION.REQUEST_QUOTE,
    eventLabel: EVENT_LABELS.QUOTE_CLICK,
  });
};
